module.exports = __webpack_public_path__ + "static/img/secondaryshanghaishehui.6c1bffc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ggw_img/secondaryshanghaishehui.jpg
// module id = oQhW
// module chunks = 46